import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19bd862e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_menu = _resolveComponent("nav-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_nav_header = _resolveComponent("nav-header")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "main-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          width: _ctx.menuFold ? '65px' : '210px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_nav_menu, { "menu-fold": _ctx.menuFold }, null, 8, ["menu-fold"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_container, { class: "page" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { class: "page-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_nav_header, { onChangeMenuFold: _ctx.changeMenuFold }, null, 8, ["onChangeMenuFold"])
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_Tab)
            ]),
            _createVNode(_component_el_main, { class: "page-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_config_provider, { locale: _ctx.zhCn }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component }) => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["locale"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}